module.exports = __webpack_public_path__ + "img/bohrungen-2.57a1074c.svg";